import { Box, Button } from '@mui/material'
import PaymentSettingSelector from './PaymentSettingSelector'
import TopToolBar from 'components/QuickSaleMobile/AppBar/TopToolBar'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import Visibility from '@mui/icons-material/Visibility'
import { useTranslation } from 'react-i18next'

function PaymentAppbar({
    onBack = () => {},
    hidePaymentSelect,
    onViewInfo,
}: {
    hidePaymentSelect?: boolean
    onBack?: () => void
    onViewInfo?: () => void
}) {
    const { t } = useTranslation()
    const { isSplitPayment } = usePaymentContext()
    return (
        <TopToolBar
            handleBackTo={onBack}
            title={
                isSplitPayment
                    ? t('finish.label.split_payment')
                    : t('finish.label.payment')
            }
        >
            <Box flexGrow={1}></Box>
            {!hidePaymentSelect && <PaymentSettingSelector />}

            {onViewInfo && (
                <Button
                    variant="text"
                    onClick={onViewInfo}
                    color="outlinePrimary"
                    startIcon={<Visibility />}
                >
                    {t('finish.label.view_info')}
                </Button>
            )}
        </TopToolBar>
    )
}
export default PaymentAppbar
